import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
import axios from "axios";

//import NewContentList from './NewContentList'
// import moment from "moment";

import ContentItem2 from "../../components/event/ContentItem2";

import "../../css/event210621.css";

import { toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

class Event202110_contentList extends Component {
  state = {
    //eventCode: 0,
    intReturn: -101,
  };
  componentDidMount = () => {
    const eventCode = this.props.childProps.eventCode;
    this._getContentList(eventCode);
  };

  _getContentList = async (eventCode) => {
    // const { loginId } = this.props;

    // const curDate = new Date();
    // const today = moment(curDate).format("YYYY-MM-DD HH:mm:ss");

    const result = await this._getContentListApi(eventCode);
    const intReturn = result.data[0].intReturn;
    const contentList = result.data[0].listData;

    //console.log(contentList)

    if (intReturn === 0) {
      this.setState({
        intReturn,
        contentList,
      });
    }
  };

  _getContentListApi = (eventCode) => {
    const { apiUrl, loginId } = this.props;

    return axios
      .post(apiUrl + "/event_202110_content", {
        params: {
          eventCode: eventCode,
          userid: loginId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };
  _expect = async (contentSerial, grade) => {
    const { keycode, _makeKeycode, _setGrade } = this.props.childProps;
    let code = "";
    //console.log(keycode)
    if (keycode === "" || keycode === null || keycode === undefined) {
      //const temp = Math.random().toString(36).substr(2,11)
      //code = temp
      //console.log('없음 새로 생성')
      //console.log(code)
      //console.log(contentSerial)
      //this.setState({
      //    keycode: code
      //})
      _makeKeycode();
    } else {
      code = keycode;
      //console.log('기존코드')
      //console.log(code)
      //console.log(contentSerial)
    }

    const result = await this._expectApi(code, contentSerial, grade);
    const intReturn = result.data[0].intReturn;

    if (intReturn === 0) {
      if (grade === 1) {
        toast.success("1차 신작백신 접종 성공! 2차 백신 접종을 시도해주세요.");
        _setGrade(2);
      } else if (grade === 2) {
        toast.success("2차 신작백신 접종 성공!");
        _setGrade(3);
        //접종 증서
      }

      //this._getContentList(eventCode)
    } else if (intReturn === -1) {
      if (grade === 1) {
        toast.warn("1차 신작백신이 이미 접종되었습니다.");
      } else if (grade === 2) {
        toast.warn("2차 신작백신이 이미 접종되었습니다.");
        //접종 증서
      }
    } else if (intReturn === -2) {
      toast.warn("1차 신작백신 접종후 2차 접종이 가능합니다.");
    }
  };
  _expectApi = (keycode, contentSerial, grade) => {
    const { apiUrl } = this.props;

    return axios.post(apiUrl + "/event_202110_expect", {
      params: {
        keycode: keycode,
        contentSerial: contentSerial,
        grade: grade,
      },
    });
  };
  _renderItem = () => {
    const { contentList, keyCode } = this.state;

    const list = contentList.map((item, index) => {
      return (
        <ContentItem2
          key={index}
          contentSerial={item.contentSerial}
          img={item.img}
          comment={item.comment}
          title={item.title}
          alramFlag={item.alram}
          keyCode={keyCode}
          _expect={this._expect}
          grade={item.rank}
        />
      );
    });
    return list;
  };
  _renderNull = () => {
    const { eventCode } = this.props.childProps;
    let test = [];

    if (eventCode === 1) {
      test = [];
    } else if (eventCode === 2) {
      test = [];
    } else if (eventCode === 3) {
      test = [];
    } else if (eventCode === 4) {
      test = [];
    } else if (eventCode === 5) {
      test = [];
    }

    const list = test.map((item, index) => {
      return (
        <li key={index} style={{ width: 224, height: 502 }}>
          <div className="thumb"></div>
        </li>
      );
    });
    return list;
  };
  _goContent = (contentSerial) => {
    const { setContentSerial } = this.props;
    setContentSerial(contentSerial);
  };
  render() {
    const { intReturn, contentList } = this.state;
    // const { eventCode } = this.props.childProps;

    // let title = "";

    // if (eventCode === 1) {
    //   title = "3/26";
    // } else if (eventCode === 2) {
    //   title = "3/27";
    // } else if (eventCode === 3) {
    //   title = "3/28";
    // } else if (eventCode === 4) {
    //   title = "3/29";
    // } else if (eventCode === 5) {
    //   title = "3/30";
    // }
    return (
      <Fragment>
        {intReturn === 0 ? (
          <ul className="list">
            {contentList ? this._renderItem() : null}
            {contentList ? this._renderNull() : null}
          </ul>
        ) : (
          <Fragment></Fragment>
        )}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event202110_contentList));
